import { lazy } from "react";

const MAX_RETRIES = 1; // prevent infinite reloads

export const lazyWithRetry = (importFunc) =>
  lazy(
    () =>
      new Promise((resolve, reject) => {
        importFunc()
          .then((module) => {
            // 🚨 Handle undefined or malformed module
            if (!module || !module.default) {
              throw new Error("Invalid lazy module (missing default export)");
            }

            resolve(module);
          })
          .catch((error) => {
            const isChunkError =
              error?.name === "ChunkLoadError" ||
              error?.message?.includes("Loading chunk") ||
              error?.message?.includes(
                "Failed to fetch dynamically imported module",
              );

            const retryCount = Number(
              sessionStorage.getItem("lazy_retry_count") || 0,
            );

            if (isChunkError && retryCount < MAX_RETRIES) {
              sessionStorage.setItem("lazy_retry_count", retryCount + 1);

              // 🔁 Hard reload to fetch fresh chunks
              window.location.replace(window.location.href);
              return;
            }

            // ❌ Do NOT retry endlessly
            sessionStorage.removeItem("lazy_retry_count");

            reject(error);
          });
      }),
  );
